import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { Section, SectionHeading, Reveal, CTASection, Button } from "@/components/ui-bits";
import { PageHero } from "@/components/shared";
import { IMG } from "@/lib/data";

const FORMATS = [
  { title: "Stick Packs", img: IMG.energy, uses: ["Energy", "Hydration", "Electrolytes", "Pre-workout", "Wellness", "Functional beverages"], note: "Ideal for" },
  { title: "Sachets", img: IMG.electrolyte, uses: ["Drink mixes", "Supplements", "Wellness products", "Sports nutrition", "Single-serve formulations"], note: "Suitable for" },
];

export default function Packaging() {
  useSEO("Stick Pack & Sachet Packaging | Wisperwick Studio",
    "Single-serve stick pack and sachet packaging for beverage mixes, hydration, electrolytes, pre-workout, wellness and functional products.");
  return (
    <div>
      <PageHero eyebrow="Packaging" title="Your product needs a format people want to carry."
        sub="Single-serve packaging built for modern, on-the-go consumers and direct-to-consumer brands." />

      <Section className="pt-0">
        <div className="grid lg:grid-cols-2 gap-5">
          {FORMATS.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.1}>
              <div className="bg-ws-card border border-ws-border rounded-2xl overflow-hidden h-full">
                <div className="aspect-[16/10] bg-ws-bg2 relative overflow-hidden">
                  <img src={f.img} alt={`${f.title} — conceptual unbranded mockup`} loading="lazy" className="w-full h-full object-cover" />
                  <span className="absolute bottom-3 left-3 label text-[0.55rem] bg-ws-bg/85 backdrop-blur text-ws-dark rounded px-2.5 py-1.5">Conceptual product imagery</span>
                </div>
                <div className="p-6 sm:p-8">
                  <h3 className="font-display text-3xl text-ws-dark">{f.title}</h3>
                  <p className="label text-ws-accent mt-5 mb-3">{f.note}</p>
                  <div className="flex flex-wrap gap-2">
                    {f.uses.map((u) => <span key={u} className="text-xs text-ws-dark border border-ws-border rounded-full px-3 py-1.5">{u}</span>)}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-5 rounded-2xl border border-dashed border-ws-border bg-ws-bg2 p-10 text-center">
            <h3 className="font-display text-2xl text-ws-dark">Other Formats</h3>
            <p className="text-ws-text2 text-sm mt-3 max-w-xl mx-auto">[EDITABLE AREA] — Add future packaging capabilities here. We do not claim formats Wisperwick Studio does not actually manufacture.</p>
          </div>
        </Reveal>

        <div className="flex justify-center mt-12"><Button to="/request-a-quote" testid="packaging-cta">Discuss Your Packaging</Button></div>
      </Section>

      <CTASection />
    </div>
  );
}
